import React, { useState, useEffect } from "react";
import { ModalCrosSvg, TableEditBtn } from "../../../images/Svgs";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getEventStudios } from "../../../API/routine";
import { getManageStudiosData, saveManageStudios, updateDressingRoomStatus } from "../../../API/routine";

const ManageStudios = ({ onSetModal, EventId, eventTitle }) => {
  const [selectedStudio, setSelectedStudio] = useState({});
  const [allData, setAllData] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [studioList, setStudioList] = useState([]);
  const [isEnabled, setIsEnabled] = useState(false);
  const [toggleLoading, setToggleLoading] = useState(false);

  const fetchStudios = async () => {
    try {
      setLoading(true);
      const response = await getManageStudiosData(EventId);
      if (response?.status) {
        // setAllData(response.data || []);
        // setIsEnabled(response.data?.is_dressing_room_enabled || false);
        setIsEnabled(response.data?.is_dressing_room_enabled || false);
        setAllData(response.data?.dates || []);
        if (response.data?.dates?.length) {
          setSelectedDate(response.data?.dates[0].event_date);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

    const handleToggleDressingRooms = async () => {
        try {
            setToggleLoading(true);
            const newStatus = !isEnabled;
            const response = await updateDressingRoomStatus(EventId, {
                is_dressing_room_enabled: newStatus,
            });

            if (response?.status) {
                setIsEnabled(newStatus);
                toast.success(newStatus? "Dressing Rooms enabled for mobile app": "Dressing Rooms disabled for mobile app");
            }
        } finally {
            setToggleLoading(false);
        }
    };

  const currentDay = allData.find((item) => item.event_date === selectedDate) || {};
  const handleChange = (studioId, field, value) => {
    setAllData((prev) =>
      prev.map((day) => {
        if (day.event_date !== selectedDate) {
          return day;
        }
        return {
          ...day,
          studios: day.studios.map((studio) =>
            studio.studio_id === studioId
              ? {
                  ...studio,
                  [field]: value,
                }
              : studio,
          ),
        };
      }),
    );
  };

  // const handleChange = (index, field, value) => {
  //   setAllData((prev) =>
  //     prev.map((day) => {
  //       if (day.event_date !== selectedDate) {
  //         return day;
  //       }
  //       return {
  //         ...day,
  //         studios: day.studios.map((studio, i) =>
  //           i === index
  //             ? {
  //                 ...studio,
  //                 [field]: value,
  //               }
  //             : studio,
  //         ),
  //       };
  //     }),
  //   );
  // };

  const handleSave = async () => {
    try {
      setIsSubmitting(true);

      const currentDay = allData.find((d) => d.event_date === selectedDate);
      // at least one completely filled row
      const filledStudios = currentDay.studios.filter(
        (studio) => studio.dressing_room?.trim() && studio.location?.trim(),
      );
      if (filledStudios.length === 0) {
        toast.error(
          "Please fill Dressing Room and Location for at least one studio",
        );
        setIsSubmitting(false);
        return;
      }
      // half-filled row check
      const invalidStudio = currentDay.studios.find((studio) => {
        const room = studio.dressing_room?.trim();
        const location = studio.location?.trim();

        return (room && !location) || (!room && location);
      });
      if (invalidStudio) {
        toast.error("Both Dressing Room and Location are required");
        setIsSubmitting(false);
        return;
      }

      const payload = {
        // assignments: filledStudios.map((studio) => ({
        assignments: currentDay.studios.map((studio) => ({
          studio_id: studio.studio_id,
          event_id: studio.event_id,
          event_date: selectedDate,
          dressing_room: studio.dressing_room,
          location: studio.location,
        })),
      };

      const response = await saveManageStudios(payload);

      if (response?.status) {
        toast.success("Saved Successfully");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleExportDayPDF = () => {
    console.log("Exporting PDF for date:", allData);
    const day = allData.find((d) => d.event_date === selectedDate);

    if (!day) return;

    const doc = new jsPDF();
    const eventDay = formatEventDate(day.event_date);
     // Header example: "Rockford Saturday Dressing Rooms"
    const reportTitle = `${eventTitle} ${eventDay} Dressing Rooms`;
    doc.setFontSize(16);
    doc.text(reportTitle, 14, 20);

    autoTable(doc, {
      startY: 30,
      head: [["Studio Name", "Dressing Room", "Location"]],
      body:
        day.studios?.map((studio) => [
          studio.studio_name,
          studio.dressing_room,
          studio.location,
        ]) || [],
    });

    doc.save(`studio_${selectedDate}.pdf`);
  };

const handleExportAllPDF = () => {
  const doc = new jsPDF();

  allData.forEach((day, index) => {
    // First day ke baad har day ke liye new page
    if (index > 0) {
      doc.addPage();
    }

    const eventDay = formatEventDay(day.event_date);

    const reportTitle = `${eventTitle} ${eventDay} Dressing Rooms`;

    doc.setFontSize(16);
    doc.text(reportTitle, 14, 20);

    autoTable(doc, {
      startY: 30,
      head: [["Studio Name", "Dressing Room", "Location"]],
      body:
        day.studios?.map((studio) => [
          studio.studio_name,
          studio.dressing_room,
          studio.location,
        ]) || [],
    });
  });

  doc.save("all_studio_assignments.pdf");
};

  const handlePrint = () => {
  let html = `
    <html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 30px;
        }

        th, td {
          border: 1px solid #ccc;
          padding: 8px;
        }

        h2 {
          margin-bottom: 5px;
        }

        h3 {
          margin-top: 30px;
        }

        @media print {
          .page-break {
            page-break-before: always;
          }
        }
      </style>
    </head>
    <body>
  `;

  allData.forEach((day, index) => {
    const eventDay = formatEventDay(day.event_date);

    const reportTitle = `${eventTitle} ${eventDay} Dressing Rooms`;

    html += `
      ${
        index > 0
          ? '<div class="page-break"></div>'
          : ''
      }

      <h2>${reportTitle}</h2>
      <h3>${day.event_date}</h3>

      <table>
        <thead>
          <tr>
            <th>Studio Name</th>
            <th>Dressing Room</th>
            <th>Location</th>
          </tr>
        </thead>

        <tbody>
          ${day.studios
            ?.map(
              (studio) => `
                <tr>
                  <td>${studio.studio_name}</td>
                  <td>${studio.dressing_room}</td>
                  <td>${studio.location}</td>
                </tr>
              `
            )
            .join("")}
        </tbody>
      </table>
    `;
  });

  html += `
    </body>
    </html>
  `;

  const win = window.open("", "_blank");
  win.document.write(html);
  win.document.close();
  win.focus();
  win.print();
};

  const getColorFromCode = (code) => {
    const colors = [
      "#FF6B6B",
      "#4ECDC4",
      "#45B7D1",
      "#96CEB4",
      "#FECA57",
      "#A29BFE",
      "#FD79A8",
      "#00B894",
      "#E17055",
      "#0984E3",
    ];

    let hash = 0;

    for (let i = 0; i < code.length; i++) {
      hash += code.charCodeAt(i);
    }

    return colors[hash % colors.length];
  };

  const configuredCount =
    currentDay?.studios?.filter(
      (studio) => studio.dressing_room?.trim() && studio.location?.trim(),
    ).length || 0;
  const totalCount = currentDay?.studios?.length || 0;
  const dayIndex = allData.findIndex((item) => item.event_date === selectedDate) + 1;

  const handleClear = () => {
    const confirmed = window.confirm(
      "Are you sure you want to clear all studio assignments for this day?",
    );
    if (!confirmed) return;
    setAllData((prev) =>
      prev.map((day) => {
        if (day.event_date !== selectedDate) {
          return day;
        }

        return {
          ...day,
          studios: day.studios.map((studio) => ({
            ...studio,
            dressing_room: "",
            location: "",
          })),
        };
      }),
    );
  };

  const formatEventDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-").map(Number);

    return new Date(year, month - 1, day).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  const formatEventDay = (dateStr) => {
    const [year, month, day] = dateStr.split("-").map(Number);

    return new Date(year, month - 1, day).toLocaleDateString("en-US", {
      weekday: "long",
    });
  };


  useEffect(() => {
    if (EventId) {
      fetchStudios();
    }
  }, [EventId]);

  return (
    <>
      <div className="modal fade show">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5 font-18 fw-bold">
                Dressing
              </h1>
              <button
                type="button"
                className="new_event_lose inter"
                onClick={() => onSetModal(false)}
              >
                <ModalCrosSvg />
              </button>
            </div>
            <div className="d-flex align-items-center justify-content-between gap-2 mb-3 p-3 pb-0 flex-wrap">
              <div className="d-flex gap-2 flex-wrap mb-3  mb-3 p-3 pb-0 flex-wrap">
                {allData.map((item) => (
                  <button
                    key={item.event_date}
                    className={`btn btn_date ${
                      selectedDate === item.event_date
                        ? "btn-dark"
                        : "btn-outline-secondary"
                    }`}
                    onClick={() => setSelectedDate(item.event_date)}
                  >
                    {formatEventDate(item.event_date)}
                  </button>
                ))}
              </div>
              <div className="d-flex justify-content-end gap-2 mb-3 p-3 pb-0 flex-wrap">
                <div className="form-check form-switch d-flex align-items-center gap-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isEnabled}
                        onChange={handleToggleDressingRooms}
                        disabled={toggleLoading}
                        id="dressingRoomToggle"
                    />

                    <label className="form-check-label fw-medium" htmlFor="dressingRoomToggle">
                        {isEnabled ? "Dressing" : "Dressing"}
                    </label>
                </div>
                <button
                  className="btn btn-success"
                  onClick={handleSave}
                  disabled={isSubmitting}
                >
                  <i className="fas fa-save me-2"></i>
                  {isSubmitting ? "Saving..." : "Save"}
                </button>

                <button
                  className="btn btn-warning"
                  onClick={handleClear}
                  disabled={isSubmitting}
                >
                  <i className="fas fa-eraser me-2"></i>
                  Clear
                </button>

                <button className="btn btn-dark" onClick={handleExportDayPDF}>
                  <i className="fas fa-file-pdf me-2"></i>
                  PDF (Day)
                </button>

                <button className="btn btn-dark" onClick={handleExportAllPDF}>
                  <i className="fas fa-file-pdf me-2"></i>
                  PDF (All)
                </button>

                <button className="btn btn-secondary" onClick={handlePrint}>
                  <i className="fas fa-print me-2"></i>
                  Print
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div id="studio-print-section">
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div className="table-responsive studio-table-scroll">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Studio Name</th>
                          <th>Dressing Room</th>
                          <th>Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...(currentDay?.studios || [])]
                          .sort((a, b) =>
                            a.studio_code.localeCompare(b.studio_code, undefined, {
                              sensitivity: "base",
                            }),
                          )
                          .map((studio, index) => (
                            <tr key={studio.studio_id}>
                              <td className="d-flex align-items-center gap-2 fw-medium">
                                <span
                                  className="first-letter"
                                  style={{
                                    backgroundColor: getColorFromCode(studio.studio_code || ""),
                                    color: "#fff",
                                  }}
                                >
                                  {studio.studio_code}
                                </span>

                                {studio.studio_name}
                              </td>

                              <td>
                                <input
                                  className="form-control"
                                  value={studio.dressing_room}
                                  onChange={(e) =>
                                    handleChange(
                                       studio.studio_id,
                                      "dressing_room",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Enter Dressing Room"
                                />
                              </td>

                              <td>
                                <input
                                  className="form-control"
                                  value={studio.location}
                                  onChange={(e) =>
                                    handleChange(
                                      studio.studio_id,
                                      "location",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Enter Location"
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <small className="text-muted fw-medium">
                        {configuredCount} of {totalCount} studios configured for
                        Day {dayIndex} -{" "}
                        {new Date(selectedDate).toLocaleDateString("en-US", {
                          month: "short",
                          day: "numeric",
                        })}
                      </small>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageStudios;
